export const REPORT_DATE_FORMAT = 'YYYY-MM-DD'
